export const authorizedCardHeaderDetails = {
    displayAuthorizeCreditCardHeaderDetails: true,
};
